import React from 'react';
import PropTypes from 'prop-types';
import {
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  FormHelperText,
} from '@mui/material';
import { VIDEO_EDIT_FIELDS } from '../../config/const.config';

const VideoEditFields = ({
  id,
  name,
  defaultValue,
  label,
  onChange,
  disabled,
  sx,
  error,
}) => (
  <FormControl fullWidth error={error !== ''} variant="filled">
    <InputLabel id={`field-${id}-select-label`}>{label}</InputLabel>
    <Select
      labelId="demo-simple-select-label"
      id={id}
      name={name}
      value={defaultValue}
      label={label}
      onChange={onChange}
      disabled={disabled}
      sx={sx}
    >
      {Object.keys(VIDEO_EDIT_FIELDS).map((k) => (
        <MenuItem key={`${id}-v-${k}`} value={k}>
          {VIDEO_EDIT_FIELDS[k]}
        </MenuItem>
      ))}
    </Select>
    {error !== '' && <FormHelperText>{error}</FormHelperText>}
  </FormControl>
);

VideoEditFields.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  defaultValue: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  sx: PropTypes.shape(),
  error: PropTypes.string,
};
VideoEditFields.defaultProps = {
  disabled: false,
  sx: {},
  error: '',
};

export default VideoEditFields;
